import { ModalActions } from '@ui-kit/components/Modal/Modal';
import DirectDebitIcon from '@/components/icons/DirectDebitIcon';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import Button from '@/ui-kit/components/Button/Button';

type Payload = { completed?: boolean };
type Props = ModalProps<Payload>;

const DirectDebitTerms = ({ closeModal, payload: { completed = false } = {} }: Props) => (
  <Modal title={completed ? 'Direct Debit set up completed' : 'Direct Debit Guarantee'}>
    <div className="flex flex-col gap-4">
      <DirectDebitIcon className="size-6" />
      <p>
        The Guarantee is offered by all banks and building societies that accept instructions to pay Direct
        Debits.
      </p>

      <p>
        If there are any changes to the amount, date or frequency of your Direct Debit we will notify you
        (normally 10 working days) in advance of your account being debited or as otherwise agreed. If you
        request Fairlo to collect a payment, confirmation of the amount and date will be given to you at the
        time of the request.
      </p>

      <p>
        If an error is made in the payment of your Direct Debit, by Fairlo or your bank or building society,
        you are entitled to a full and immediate refund of the amount paid from your bank or building society.
      </p>

      <p>If you receive a refund you are not entitled to you must pay it back when we ask you to.</p>

      <p>
        You can cancel a Direct Debit at any time by simply contacting your bank or building society. Written
        confirmation may be required. Please also notify us.
      </p>
    </div>
    {completed ? (
      <ModalActions>
        <Button onClick={closeModal}>Done</Button>
      </ModalActions>
    ) : null}
  </Modal>
);

export default DirectDebitTerms;
